import { IconProps } from './icon.props';

const IconSVG = ({
  Icon,
  stroke = '#000000',
  fill = '#000000',
  className,
  size = 25,
}: IconProps) => {
  return (
    <Icon
      stroke={stroke}
      fill={fill}
      className={className}
      width={`${size}px`}
      height={`${size}px`}
    />
  );
};

export default IconSVG;
